import { isString } from '../utils.js';
import { hex } from './hex.js';
import { hsla } from './hsla.js';
import { rgba } from './rgba.js';
var color = {
  test: function (v) {
    return rgba.test(v) || hex.test(v) || hsla.test(v);
  },
  parse: function (v) {
    if (rgba.test(v)) {
      return rgba.parse(v);
    } else if (hsla.test(v)) {
      return hsla.parse(v);
    } else {
      return hex.parse(v);
    }
  },
  transform: function (v) {
    return isString(v) ? v : v.hasOwnProperty('red') ? rgba.transform(v) : hsla.transform(v);
  }
};
export { color };